









































import {Component, Vue} from "vue-property-decorator";
import LoadSpinner from "@/resources/components/LoadSpinner.vue";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";

@Component({
    components: {LoadingOverlay, LoadSpinner}
})
export default class PasswordReset extends Vue {
    private password: string = '';
    private passwordConfirmation: string = '';

    async resetPassword() {
        this.resetFlash();
        await this.task<void>(async () => {
            await this.$store.dispatch('auth/resetPassword', {
                password: this.password,
                password_confirmation: this.passwordConfirmation,
                email: this.$route.query.email as string,
                token: this.$route.params.token as string,
            });
        });

        await this.$router.replace({name: 'dashboard'});
    }
}
